import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Column, Workbook }  from 'exceljs';
import * as fs from 'file-saver';
import {NotificationService} from "./notification.service";


@Injectable({
  providedIn: 'root',
})
export class FilesService {

  constructor(
    public dialog: MatDialog,
    private notify: NotificationService,
  ) {
  }

  downloadPDF(
    format: string | 'pdf',
    fileName: string | 'file.pdf',
    base64: string,
    dataFormat: string | 'application/pdf'
  ) {
    const linkSource = 'data:' + dataFormat + ';base64,' + base64;
    const downloadLink = document.createElement('a');
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }


  b64toBlob(b64Data:string, contentType:string, sliceSize = 512) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) byteNumbers[i] = slice.charCodeAt(i);
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return URL.createObjectURL(blob);
  }

  // USAGE
  //
  // this.system-configurations.exportExcel(
  //   this.canditates,
  //   this.columns,
  //   this.filename,
  //   this.sheetName
  // );

  // columns = [
  //   { header: 'S/N', key: 'id', width: 5 },
  //   { header: 'Full Name', key: 'fullname', width: 45 },
  // ];

  async exportExcel(data:any[], columns:Column[], fileName = 'Report', sheetName = 'data') {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(sheetName);
    worksheet.columns = columns;
    data.forEach((e) => worksheet.addRow(e, 'n'));

    data.forEach((row, index) => {
      if (index % 2 == 0) return;
      worksheet.getRow(index + 2).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'f2f2f2' },
      };
    });

    // font
    worksheet.getRow(1).font = {
      name: 'calibri',
      size: 12,
      bold: true,
      color: { argb: '27445c' },
    };

    // fill
    worksheet.getRow(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'ebebeb' },
    };

    //border
    worksheet.getRow(1).border = {
      bottom: {style:'thick', color: {argb:'0183DB'}},
    };

    worksheet.getRow(1).alignment = { horizontal: 'left' };

    await workbook.xlsx.writeBuffer().then((data: BlobPart) => {
      const type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      const blob = new Blob([data], {type});
      fs.saveAs(blob, fileName + '.xlsx');
    });

    return true;
  }

  readExcel($event,columns:string[]):any{
    if(!($event?.target?.files)) return [];
    const selectedFile  = $event.target.files[0];

    if(selectedFile.name?.split('.').slice(-1)[0] !=='xlsx')  {
      this.notify.errorMessage('Only .xlsx file allowed');
      return [];
    }

    return this.importExcel($event, columns);
  }

  async importExcel(event,columns:string[]){
    const workbook = new Workbook();
    const target: DataTransfer = <DataTransfer>(event.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');

    const arryBuffer = new Response(target.files[0]).arrayBuffer();
    let buffer = [];

    return arryBuffer.then(function (data) {
      return workbook.xlsx.load(data).then(async function () {
          // play with workbook and worksheet now
          const worksheet = workbook.getWorksheet(1);
          buffer = [];
          worksheet.eachRow(function (row, rowNumber) {
            const r = [...<any>row.values];
            //first col is the index skip it
            r.shift();

            //get field //push to buffer
            const field = {};
            columns.forEach((key, index) =>  !!r?.[index] && (field[key]=r?.[index]));
            if(field?.[columns?.[0]]) buffer.push(field);
            return buffer;

          });
        }).then(b => {
          //first row is the header skip it
          buffer.shift();
          return buffer;
        });
    }).then(b => {return buffer;});
  }

}
